import mutateItem from './mutateItem';
/**
 *
 * @param {String} workItem The key you would like to apply a mutator to.
 * @param {String} replacement Current replacement value at time of function call
 * @returns string
 * @description Allows you to mutate the value of a given key for a given client's formatting need.
 * Ex: A client wants strings to be all lowercase.
 */
const handlePayloadMutators = (workItem, replacement, payloadMutator = {}) => {
	const mutators = payloadMutator?.[workItem];
	return mutators ? mutateItem(mutators, replacement) : replacement;
};

export default handlePayloadMutators;
